import type { LayoutLoad } from './$types';

export const ssr = false;
export const prerender = false;

export const load = (() => {}) satisfies LayoutLoad;
